import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@mui/styles'
import clsx from 'clsx'
import { Link } from 'react-router'

const useStyles = makeStyles(theme => ({
  card: {
    width: 250,
    display: 'block',
    padding: 10,
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    color: theme.textColor,
    padding: '20px 30px 30px',
    borderColor: theme.borderColor,
    borderWidth: 1,
    borderStyle: 'solid',
    borderRadius: theme.borderRadius,
    height: 300,
    '&:hover': {
      borderColor: theme.activeInputBorder,
      color: theme.textColor,
    },
    background: '#fff',
  },
}))

const Card = ({ children, className, href }) => {
  const classes = useStyles()

  return (
    <div className={clsx(classes.card, className)}>
      <Link to={href} className={classes.content}>{children}</Link>
    </div>
  )
}

Card.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.element,
  ]),
  href: PropTypes.string,
  className: PropTypes.string,
}

Card.defaultProps = {
  children: null,
  href: '#',
  className: null,
}

export default Card
